module.exports = __webpack_public_path__ + "static/media/kultura-w-sieci.bb877177.svg";